import { ListaItem } from './lista-item';
import { Usuario } from './usuario';
import { Sede } from './sede';
import { Compania } from './compania';
import { AsignacionDispositivoDto } from './asignacion-dispositivos';

export class Vlan {
  idVlan: number;
  nombreVlan: string;
  mascara: ListaItem;
  ambiente: ListaItem;
  fechaCreada: string;
  usuarioCrea: string;
  fechaInactiva: string;
  usuarioInactiva: string;
  sede: Sede;
  companias: Compania[];
  ipInicialRango: string;
  ipFinalRango: string;
  indHabilitado: boolean;
  observaciones: string;
  gateway: string;
  asignaciones: AsignacionDispositivoDto[];
}



// WEBPACK FOOTER //
// ./src/app/shared/models/vlan.ts